import { MEETINGMANAGEMENT_URL } from "utils/constants";
import { ENDPOINTSMEETINGSMANAGEMENT } from "utils/endpoints";
import { http } from "utils/http";


export const getMeetingById = (async (id) => await http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.load,
    headers: { "Accept-Language": "en" },
    method: 'get',
    params: {Id : id}
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)

export const sendmeeting = (data , method ,processId ,referenceId,pendToAccept) => http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.browse,
    method: method,
    params:{
        PrjUid: processId,
        referenceId:referenceId,
        ...(method=="put"?{pendToAccept}:{})
    },
    data:data
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
})




export const SendInvitationApi = (data ,referenceId) => http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.SendInvitation,
    method: "put",
    params:{

        referenceId:referenceId
    },
    data:data
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
})




export const SendIsPreparedMeetingConditions = (referenceId,meetingId) => http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.IsPreparedMeetingConditions,
    method: "put",
    params:{

        referenceId,
        meetingId
    },
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
})




export const updateMeetingMinutes = (data) => http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.putMinute,
    method: "put",
    data : data
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

export const checkPlaceConflict = (data) => http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.conflict ,
    method: "put",
    data:data

}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})


